import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithClient } from "@/redux/baseQuery";
import { ClientAdminSettings, UpdateAdminSettingsParams } from "./types";

export const clientAdminSettingsApi = createApi({
  reducerPath: "clientAdminSettingsApi",
  baseQuery: baseQueryWithClient(),
  tagTypes: ["ClientAdminSettings"],
  endpoints: (builder) => ({
    getAdminSettings: builder.query<ClientAdminSettings, { accountId?: string } | void>({
      query: (arg) => ({ url: "/admin-settings", accountId: arg?.accountId }),
      providesTags: ["ClientAdminSettings"],
    }),
    updateAdminSettings: builder.mutation<ClientAdminSettings, UpdateAdminSettingsParams>({
      // accountId targets the managed client via baseQueryWithClient; kept out of the body.
      query: ({ accountId, ...body }) => ({
        url: "/admin-settings",
        method: "PATCH",
        body,
        accountId,
      }),
      invalidatesTags: ["ClientAdminSettings"],
    }),
  }),
});

export const { useGetAdminSettingsQuery, useUpdateAdminSettingsMutation } = clientAdminSettingsApi;
